$.noConflict();
jQuery(document).ready(function(){
  jQuery('.navbar-toggler').click(function(e) {  
    if (e.target.id == "showCollapse"){ 
      jQuery('.collapse').collapse('show');
    } else if (e.target.id == "hideCollapse"){
      jQuery('.collapse').collapse('hide');
    }
    
  });
  
});